module.exports = __webpack_public_path__ + "img/code_gou.8e00921d.png";